import { Box } from "@material-ui/core"

export default function Logo(){
    return (
        <Box display="flex" alignItems="center">
            <img src={`${process.env.PUBLIC_URL}/images/nx-logo.svg`} alt="logo" height={50}/>
        </Box>
    )
}